import { Pipe, PipeTransform } from '@angular/core';

import { XMLHelperService } from '@services';
import { HTMLExtractionPrefix } from 'src/app/shared/common/enums';

@Pipe({
  name: 'htmlExtractor',
})
export class HtmlExtractorPipe implements PipeTransform {
  constructor(private xmlHelperService: XMLHelperService) {}

  transform(html: string, htmlElement: string, prefix?: HTMLExtractionPrefix): string[] | null {
    if (!htmlElement) {
      return null;
    }

    let json = null;
    try {
      // XML files should only have 1 root element so wrapping it in 'dummy' div
      json = this.xmlHelperService.getJsonFromXMLString(`<div>` + html + `</div>`);
    } catch {
      return null;
    }

    if (!json) {
      return null;
    }

    let extractedTags: string[] = [];
    this.eachRecursive(json, htmlElement, extractedTags);
    if (extractedTags) {
      return prefix ? extractedTags.map((tag) => `${prefix} ${tag}`) : extractedTags;
    } else {
      return null;
    }
  }

  eachRecursive(obj: any, tag: string, result: string[]): void {
    for (let key in obj) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        this.eachRecursive(obj[key], tag, result);
      } else {
        result.push(obj[key]);
      }
    }
  }
}
